import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "mf-proactive-case-closure-modal",
    shadow: false
})
export class ProactiveCaseClosureModal {
    // @ts-expect-error - modal is a HTMLUxModalElement
    private modal: HTMLUxModalElement;
    private successMessageWasShown = false;

    /**
     * SIS case ID
     */
    @Prop() callId: string;
    /**
     * The locale to use for translations
     */
    @Prop() locale: string;
    /**
     * Identifier for the modal - see ux.ui docs
     */
    @Prop() modalName: string;
    /**
     * Environment to use for API calls
     */
    @Prop() env: string = "prod";

    private handleClose = () => {
        this.modal.triggerClose();
    };

    private handleModalClose = () => {
        if (this.successMessageWasShown) {
            window.location.reload();
        }
    };

    render() {
        return (
            <Host>
                <ux-modal
                    onUxModalClose={() => this.handleModalClose()}
                    name={this.modalName}
                    ref={(el: HTMLElement) => (this.modal = el)}
                >
                    <ux-modal-content>
                        <mf-proactive-case-closure
                            callId={this.callId}
                            locale={this.locale}
                            onMfServiceCallCancel={() => this.handleClose()}
                            onMfServiceCallSuccess={() => {
                                this.handleClose();
                                window.location.reload();
                            }}
                            onMfServiceCallShowSuccess={() => (this.successMessageWasShown = true)}
                            env={this.env}
                        />
                    </ux-modal-content>
                </ux-modal>
            </Host>
        );
    }
}

export interface ProactiveCaseClosureModalProps {
    /** SIS case ID */
    callId: string;
    /**
     * The locale to use for translations
     */
    locale: string;
    /** Identifier for the modal - see ux.ui docs */
    modalName: string;
}
